import { render } from "./LiveGameHeader.vue?vue&type=template&id=7e69ff5e"
import script from "./LiveGameHeader.vue?vue&type=script&lang=js"
export * from "./LiveGameHeader.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/gilcode.com/kwordz.gilcode.com/packages/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__